module.exports = __webpack_public_path__ + "img/product-container-1-bg-mobile.25d5ef9c.png";